<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
const debounce = (fn, delay) => {
  let timer
  return (...args) => {
    if (timer) {
      clearTimeout(timer)
    }
    timer = setTimeout(() => {
      fn(...args)
    }, delay)
  }
}

const _ResizeObserver = window.ResizeObserver
window.ResizeObserver = class ResizeObserver extends _ResizeObserver {
  constructor(callback) {
    callback = debounce(callback, 200)
    super(callback)
  }
}

export default {
  name: 'App'
}
</script>

<style>
/* 使用 html 和 body 选择器 */
html, body {
  margin: 0;
  padding: 0;
  height: 100%;
}

/* 全局重置 */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

/* 全局字体和抗锯齿 */
body {
  font-family: -apple-system, 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei',
    'WenQuanYi Micro Hei', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  letter-spacing: 0.03em;
}

/* 可选：链接样式重置 */
a {
  text-decoration: none;
  color: inherit;
}

/* 可选：输入框和按钮样式重置 */
input, 
button {
  outline: none;
  border: none;
  background: none;
  font-family: inherit;
}

/* 可选：列表样式重置 */
ul, ol {
  list-style: none;
}

/* 可选：#app 样式 */
#app {
  height: 100%;
}
</style>
